<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-01 16:48:38
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/multilingual/components/MainPageCard.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
 
    <div :class="customClass" class="bg-white  br-10 p-14 border-box text-left " style="box-shadow: 0px 4px 30px 0px rgba(0,0,0,0.12);">
      <div class="d-flex a-center">
            <img class="flex-shrink-0  mr-5" :src="userBaseInfoVo.companyLogo" v-if="userBaseInfoVo.companyLogo" alt="" style="width: 21px;height: 21px;border-radius:4px;">
            <div class="text-ellipsis-overflow-1 cor-262626 fw-5 fz-11" style="width: 300px">{{userBaseInfoVo.companyName}}</div>
          </div>
      <div class="d-flex">
        <div class="d-flex flex-column flex-wrap" style="width: 190px;padding-top:7px;">
          
          <div class="" style="width: 190px;">
            <div class="d-flex a-center flex-wrap">
              <div class="mr-5 fz-19 fw-7 text-ellipsis-1 cor-262626" style="max-width: 158px;">
                {{ userBaseInfoVo.name }}
              </div>
              <!-- <div class="d-flex flex-center  border-box lh-11">
                <img v-if="userBaseInfoVo.isRealName" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/images/authGif/auth.gif" style="width: 17px; height: 17px;">
                <img v-else class="br-100 mr-5 p-relative" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/divs/no-realName.png" mode="" style="width: 17px; height: 17px; top: 1px">
              </div> -->
            </div>
            <div class="fz-14 cor-8C8C8C  text-ellipsis-1 mt-5" style="max-width: 190px">
              {{ userBaseInfoVo.position }}
            </div>
          </div>
          <div style="width: 190px;margin-top: auto;">
            <div class="d-flex a-center mt-7 cor-262626">
              <div class="iconfont mr-5 fz-17">{{ `\ue737` }}</div>
              <div class="fz-14  text-ellipsis-1" style="width: 170px">{{userBaseInfoVo.phoneCountryCode}} {{userBaseInfoVo.phone}}</div>
            </div>
            <div class="d-flex a-center mt-5 cor-262626" v-if="userBaseInfoVo.email">
              <div class="iconfont mr-5 fz-17">{{ `\ue72f` }}</div>
              <div class="fz-14 text-ellipsis-1" style="width: 170px">{{ userBaseInfoVo.email }}</div>
            </div>
            
          </div>
        </div>
        <!-- 右边 -->
        <div class="ml-auto f-shrink d-flex flex-column p-relative mt-7">
          <img class="d-block" style="width: 100px; height: 100px" :src="userBaseInfoVo.qrCodeUrl" />
          <img class="" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetQrcodeIcon.png" style="width: 61px; height: 15px; margin: 8px auto 0" />
        </div>
      </div>
      <div class="d-flex a-center mt-5 cor-262626" v-if="userBaseInfoVo.fullAddress">
              <div class="iconfont mr-5 fz-17">{{ `\ue729` }}</div>
              <div class="fz-14  text-ellipsis-1" style="width: 300px" @click="copyWord" id="copyWord" :data-clipboard-text="userBaseInfoVo.fullAddress">{{ userBaseInfoVo.fullAddress }}</div>
            </div>
    </div>
 
</template>
<script>
import Clipboard from 'clipboard'
export default {
  name: 'MainPageCard',
  props: {
    customClass: {
      type: String,
      default: 'mx-12',
    },
    userBaseInfoVo: {
      type: Object,
      default: '',
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {
    copyWord() {
      var _this = this
      var clipboard = new Clipboard('#copyWord')
      clipboard.on('success', (e) => {
        _this.$toast.success('地址已复制')
        //  释放内存

        clipboard.destroy()
      })

      clipboard.on('error', (e) => {
        console.log(e)
        // 不支持复制
        _this.$toast.fail('该浏览器不支持复制')
        // 释放内存
        clipboard.destroy()
      })
    },
  },
  mounted() {},
}
</script>


